import { toast } from '@nile/components';

function ErrorToast({
  type = 'error',
  message = 'An error occurred. If the issue persists,please reconnect to the chat.'
}) {
  return toast(type, message, null, null, {
    autoClose: false,
    closeButton: false,
    closeOnClick: false,
    bodyClassName: 'min-height-50 flex actr',
    draggable: false
  });
}

export default ErrorToast;
